<template>
  <restaurantProductsCategorie :typeEndPoint="'papeleriaProductsCategoriesForm'" :dataParams="{}" />
</template>
<script>
import restaurantProductsCategorie from '@/components/modules/papeleria/products/categories/form'
export default {
  name: 'restaurantProductsCategories',
  components: {
    restaurantProductsCategorie
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/papeleria/products/categories/create.vue